import InstagramIcon from './InstagramIcon';

export default InstagramIcon;
